import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetUserOverviewsResponse extends BackendResponse {
  items: UserOverview[];
  total: number;
}

export interface GetUserOverviewsParams extends NextApiParams {
  emailFilter?: string;
  nameFilter?: string;
  phoneFilter?: string;
  concernFilter?: number;
  candidateFilter?: number;
  filterOperator?: string;
}

export const getUserOverviews = withNextApi<
  GetUserOverviewsResponse,
  GetUserOverviewsParams
>("/auth/GetUserOverviews", { method: "GET" });

export interface UserOverview {
  lastLoginId: number;
  email: string;
  concernId: number | null;
  nameInWebtemp: string | null;
  phoneInWebtemp: string | null;
  lastLoggedInTime: string | null;
  accountLinkId: number | null;
  candidateId: number | null;
  guid: string | null;
  provider: string | null;
}
